// Steps

export const STEP_START = 'START';
export const STEP_INTRO = 'SECTION_INTRO';
export const STEP_QUESTIONS = 'SECTION_QUESTIONS';
export const STEP_FINISH = 'FINISH';

// Status

export const GET_STATUS = 'legend/assessment/GET_STATUS';
export const GET_STATUS_SUCCESS = 'legend/assessment/GET_STATUS_SUCCESS';
export const GET_STATUS_FAIL = 'legend/assessment/GET_STATUS_FAIL';

export const SET_ASSESSMENT_STATUS = 'ASSESSMENT_STATUS';
export const GET_ASSESSMENT_REPORT_LINKS = 'legend/assessment/GET_ASSESSMENT_REPORT_LINKS';
export const GET_ASSESSMENT_REPORT_LINKS_SUCCESS = 'legend/assessment/GET_ASSESSMENT_REPORT_LINKS_SUCCESS';
export const GET_ASSESSMENT_REPORT_LINKS_FAIL = 'legend/assessment/GET_ASSESSMENT_REPORT_LINKS_FAIL';


// RESEND INSTRUCTIONS
export const RESEND_ASSESSMENT_INSTRUCTIONS = 'legend/assessment/RESEND_ASSESSMENT_INSTRUCTIONS';
export const RESEND_ASSESSMENT_INSTRUCTIONS_SUCCESS = 'legend/assessment/RESEND_ASSESSMENT_INSTRUCTIONS_SUCCESS';
export const RESEND_ASSESSMENT_INSTRUCTIONS_FAIL = 'legend/assessment/RESEND_ASSESSMENT_INSTRUCTIONS_FAIL';

// ORDER ASSESSMENT REPORTS
export const ORDER_ASSESSMENT_REPORTS = 'legend/assessmentr/ORDER_ASSESSMENT_REPORTS';
export const ORDER_ASSESSMENT_REPORTS_SUCCESS = 'legend/assessment/ORDER_ASSESSMENT_REPORTS_SUCCESS';
export const ORDER_ASSESSMENT_REPORTS_FAIL = 'legend/assessment/ORDER_ASSESSMENT_REPORTS_FAIL';

// CANCEL REPORTS
export const CANCEL_ASSESSMENT_REPORTS = 'legend/assessment/CANCEL_ASSESSMENT_REPORTS';

// STATUS
export const CANCEL_ASSESSMENT_STATUS_FAIL = 'legend/assessment/CANCEL_ASSESSMENT_STATUS_FAIL';
export const CANCEL_ASSESSMENT_STATUS_SUCCESS = 'legend/assessment/CANCEL_ASSESSMENT_STATUS_SUCCESS';

// GET ASSESSMENT
export const GET_ASSESSMENT = 'legend/assessment/GET_ASSESSMENT';
export const GET_ASSESSMENT_SUCCESS = 'legend/assessment/GET_ASSESSMENT_SUCCESS';
export const GET_ASSESSMENT_FAIL = 'legend/assessment/GET_ASSESSMENT_FAIL';
export const GET_EDIT_ASSESSMENT = 'legend/assessment/GET_EDIT_ASSESSMENT';

// EDIT ASSESSMENT
export const EDIT_ASSESSMENT = 'legend/assessment/EDIT_ASSESSMENT';
export const EDIT_ASSESSMENT_SUCCESS = 'legend/assessment/EDIT_ASSESSMENT_SUCCESS';
export const EDIT_ASSESSMENT_FAIL = 'legend/assessment/EDIT_ASSESSMENT_FAIL';

export const GET_INTRO_CONTENT = 'legend/assessmentSectionIntro/GET_SECTION_INTRO_CONTENT';
export const GET_INTRO_CONTENT_SUCCESS = 'legend/assessmentSectionIntro/GET_SECTION_INTRO_CONTENT_SUCCESS';
export const GET_INTRO_CONTENT_FAIL = 'legend/assessmentSectionIntro/GET_SECTION_INTRO_CONTENT_FAIL';

export const SAVE_INTRO_PROGRESS = 'legend/assessmentSectionIntro/SAVE_INTRO_PROGRESS';
export const SAVE_INTRO_PROGRESS_SUCCESS = 'legend/assessmentSectionIntro/SAVE_INTRO_PROGRESS_SUCCESS';
export const SAVE_INTRO_PROGRESS_FAIL = 'legend/assessmentSectionIntro/SAVE_INTRO_PROGRESS_FAIL';

